<div class="baloon" [ngStyle]="styles">{{content}}</div>
